import { render, staticRenderFns } from "./FormattedDate.vue?vue&type=template&id=148399e5&"
import script from "./FormattedDate.vue?vue&type=script&lang=js&"
export * from "./FormattedDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports